
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class BursBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "BursBasvuruSave";
    super(baseUrl);
  }


  saveBursBasvuruSave(request: BursBasvuruSaveRequest){
    
    return this.post("", request, false);
   
  }

}
export default new BursBasvuruAPI();

class BursBasvuruSaveRequest {
    basvuruTuruId: number;
    tcKimlikNo: number;
    dogumTarihi: Date;
    ad: string;
    soyad: string;
    cepTelefonu: string;
    evTelefonu?: string;
    acikAdres: string;
    okulId: string;
    fakulteId: string;
    sinifi?: string;
    puani?: number;
    bursTuruKodu: number;
    ozelDurumKodu?: number;
    aileninToplamGeliri: number;
    okuyanKardesSayisi?: number;
    ibanNo?: string;
    captchaToken?: string;

    constructor(
        basvuruTuruId: number,
        tcKimlikNo: number,
        dogumTarihi: Date,
        ad: string,
        soyad: string,
        cepTelefonu: string,
        aileninToplamGeliri: number,
        acikAdres: string,
        okulId: string,
        fakulteId: string,
        bursTuruKodu: number,
        evTelefonu?: string,
        sinifi?: string,
        puani?: number,
        ozelDurumKodu?: number,
        okuyanKardesSayisi?: number,
        ibanNo?: string,
        captchaToken?: string
    ) {
        this.basvuruTuruId = basvuruTuruId;
        this.tcKimlikNo = tcKimlikNo;
        this.dogumTarihi = dogumTarihi;
        this.ad = ad;
        this.soyad = soyad;
        this.cepTelefonu = cepTelefonu;
        this.evTelefonu = evTelefonu;
        this.acikAdres = acikAdres;
        this.okulId = okulId;
        this.fakulteId = fakulteId;
        this.sinifi = sinifi;
        this.puani = puani;
        this.bursTuruKodu = bursTuruKodu;
        this.ozelDurumKodu = ozelDurumKodu;
        this.aileninToplamGeliri = aileninToplamGeliri;
        this.okuyanKardesSayisi = okuyanKardesSayisi;
        this.ibanNo = ibanNo;
        this.captchaToken = captchaToken;
    }
}
export {BursBasvuruSaveRequest};
